import React from 'react';
import PropTypes from 'prop-types';

export default class CircularProgress extends React.PureComponent {
  static propTypes = {
    strokeWidth: PropTypes.number,
    progress: PropTypes.number,
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    primaryTextColor: PropTypes.string,
    secondaryTextColor: PropTypes.string,
    progressFraction: PropTypes.string,
    sqSize: PropTypes.number,
  }

  render() {
    const {
      strokeWidth,
      progress,
      backgroundColor,
      color,
      primaryTextColor,
      secondaryTextColor,
      progressFraction,
      // Size of the enclosing square
      sqSize,
    } = this.props;

    // SVG centers the stroke width on the radius, subtract out so circle fits in square
    const radius = (sqSize - strokeWidth) / 2;
    // Enclose cicle in a circumscribing square
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    // Arc length at 100% coverage is the circle circumference
    const dashArray = radius * Math.PI * 2;
    // Scale 100% coverage overlay with the actual percent
    const dashOffset = dashArray - ((dashArray * progress) / 100);

    return (
      <div className="ax-circular-progress">
        <svg
          width={sqSize}
          height={sqSize}
          viewBox={viewBox}
        >
          <circle
            className="circle-background"
            cx={sqSize / 2}
            cy={sqSize / 2}
            r={radius}
            strokeWidth={`${strokeWidth}px`}
            style={{ stroke: backgroundColor }}
          />
          <circle
            className="circle-progress"
            cx={sqSize / 2}
            cy={sqSize / 2}
            r={radius}
            strokeWidth={`${strokeWidth}px`}
            // Start progress marker at 12 O'Clock
            transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
            style={{
              strokeDasharray: dashArray,
              strokeDashoffset: dashOffset,
              stroke: color,
            }}
          />
        </svg>
        <div
          className="circle-text-container"
          style={{ color: primaryTextColor }}
        >
          <div className="percentage-number">
            {`${progress}`}
            <div className="percentage-symbol" style={{ color: secondaryTextColor }}>%</div>
            <div className="progress-fraction" style={{ color: secondaryTextColor }}>
              {progressFraction}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CircularProgress.defaultProps = {
  sqSize: 132,
  progress: 0,
  strokeWidth: 8,
};
